module.exports = __webpack_public_path__ + "static/media/Horizontal-Digital-Whiteboard.4675d4f5.jpg";